import React, { Component } from "react";
import SubTestSettings from "../../components/subtestsettings";

class SubTestSettingsPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      translate,
      languages,

      roles
    } = this.props;

    //const { pager } = this.state;
    return (
      <SubTestSettings
        translate={translate}
        languages={languages}
        roles={roles}
      />
    );
  }
}

export default SubTestSettingsPage;



// WEBPACK FOOTER //
// ./src/pages/subtestsettings/index.js